<template lang="pug">
  div.container-fluid.background-login.vertical-center.px-0
    div.row.d-flex.justify-content-center
      div.col-12.mb-2
        div.card
          div.card-header
            | Händler-Login
          div.card-body
            p Willkommen im Händler-Bereich der MALU WILZ Beauté GmbH.
            P Als autorisierter Geschäftspartner haben Sie hier Zugang zu unserem B2B-Shop, um schnell und unkompliziert zu bestellen, Ihren Auftragsstatus nachzuverfolgen, bisherige Bestellungen anzusehen sowie persönliche Daten zu bearbeiten.
            P Zudem steht Ihnen unser Downloadbereich mit vielfältigen Informationen zu unseren Neuheiten sowie Bildmaterial zur Verfügung.
      template(v-if="authenticated")
        button.btn.btn-primary.pull-right(
          type="button"
          @click.stop="showMenu"
          )
          | Zum Menü
      template(v-if="!authenticated")
        div.col-12.col-sm-12.col-md-6.col-lg-6.my-4
          div.card
            div.card-header
              | Ich habe noch kein Konto
            div.card-body
              p Sie sind MALU WILZ Kosmetiker?
              p Um einen Händler-Account zu erhalten, rufen Sie uns bitte an unter&nbsp;
                strong.no-wrap +49 (0)8131 / 390 - 02
                | .
        div.col-12.col-sm-12.col-md-6.col-lg-6.my-4
          div.card
            div.card-header
              | Ich habe bereits ein Konto
            div.card-body
              | Melden Sie sich mit Ihrer E-Mailadresse und Ihrem Kennwort an.
            div.card-body.d-flex
              button.btn.btn-secondary(
                type="button"
                @click.stop="forgotPassword"
                )
                | Kennwort vergessen?
              div.flex-fill
              button.btn.btn-primary.pull-right(
                type="button"
                @click.stop="showLogin"
                )
                | Zum Login
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'StartPage',
  computed: {
    ...mapState('authentication', [
      'authenticated'
    ])
  },
  methods: {
    ...mapActions('ui', [
      'forgotPassword',
      'showLogin',
      'showMenu'
    ])
  }
}
</script>
